import {
    APC_COMPARISON_SESSION_ID,
    COMPARISON_SESSION_ID,
} from '../config/consts';

export function makeId(maxidLen = 5) {
    let text = '';
    const possible = 'abcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < maxidLen; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
}

/**
 * getCompareSessionId
 * @returns {string} - sessionId
 */
export default function() {
    const localStorageNameAPC = APC_COMPARISON_SESSION_ID || 'APC_COMPARISON_SESSION_ID';
    const localStorageName = COMPARISON_SESSION_ID || 'COMPARISON_SESSION_ID';
    let APCsessionId = localStorage.getItem(localStorageNameAPC);
    let sessionId = localStorage.getItem(localStorageName);

    if (!APCsessionId) {
        APCsessionId = makeId();
        localStorage.setItem(localStorageNameAPC, APCsessionId);
        return APCsessionId;
    }

    if (!sessionId) {
        sessionId = makeId();
        localStorage.setItem(localStorageName, sessionId);
        return sessionId;
    }

    return;
}
